import React, { useRef, useState } from "react"
import { Waypoint } from "react-waypoint"
import { Formik } from "formik"
import Success from "../../images/success-tick.png"

import {
  Overlay,
  Container,
  Caption,
  FormWrapper,
  ImageWrapper,
  CloseButton,
} from "./style.js"
import { NewsletterPopupData } from "../../hooks/newsletter-pop-up-data"
import { useSignupSubmission } from "../../hooks/useSignupSubmission"
import { SIGNUP_STATES, validateSignupValues } from "../../utils/signup"
import useClose from "../../hooks/useClose"
import { ResponsiveGatsbyImage } from "../ResponsiveGatsbyImage"
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock"
import { ReactComponent as ErrorIcon } from "../../images/invalid-email.svg"

import { ReactComponent as Cross } from "../../images/close-btn.svg"
import Cookies from "js-cookie"

import { ErrorMessage } from "../SignUp/style.js"
const NewsletterPopup = () => {
  const modalRef = useRef(null)
  const newsletterPopup = NewsletterPopupData()
  const [show, setShow] = useState(false)
  const {
    submissionState,
    submitError,
    submitSignup,
    resetFeedback,
  } = useSignupSubmission("newsletter_popup")

  const isSubmitting = submissionState === SIGNUP_STATES.submitting
  const isSuccess = submissionState === SIGNUP_STATES.success

  const close = () => {
    if (show) {
      enableBodyScroll(modalRef.current)
      setTimeout(() => setShow(false), 50)
    }
  }
  useClose(modalRef, () => close())

  const {
    description,
    heading,
    image,
    imageCaption,
    inputPlaceholder,
    submitButtonText,
  } = newsletterPopup

  if (!heading) return null
  const cookieId = "seen-ig-popup"

  const handleWaypointCross = () => {
    const hasSeen = Cookies.get(cookieId)

    if (!hasSeen) {
      Cookies.set(cookieId, true, { expires: 30 })
      setShow(true)

      setTimeout(() => {
        const storedRequestAnimationFrame = window.requestAnimationFrame

        window.requestAnimationFrame = () => 42
        disableBodyScroll(modalRef.current)
        window.requestAnimationFrame = storedRequestAnimationFrame
        // disableBodyScroll(modalRef.current)
      }, 50)
    }
  }

  return (
    <div>
      <Waypoint onEnter={handleWaypointCross} />
      {show && (
        <Overlay>
          <Container ref={modalRef}>
            <CloseButton onClick={() => close()}>
              <Cross />
            </CloseButton>
            <ImageWrapper>
              <ResponsiveGatsbyImage
                src={image.sourceUrl}
                srcSet={image.srcSet}
              />
              {imageCaption && (
                <Caption dangerouslySetInnerHTML={{ __html: imageCaption }} />
              )}
            </ImageWrapper>

            <Formik
              initialValues={{ email: "", website: "" }}
              validateOnChange={false}
              validate={validateSignupValues}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                const didSucceed = await submitSignup(values)

                setSubmitting(false)

                if (didSucceed) {
                  resetForm()
                }
              }}
            >
              {({ values, errors, handleChange, handleSubmit }) => (
                <FormWrapper onSubmit={handleSubmit}>
                  {heading && <h1>{heading}</h1>}
                  {description && <h3>{description}</h3>}
                  {!isSuccess ? (
                    <input
                      type="text"
                      name="email"
                      id="email"
                      placeholder={inputPlaceholder}
                      value={isSuccess ? "" : values.email}
                      onChange={event => {
                        resetFeedback()
                        handleChange(event)
                      }}
                      spellCheck={false}
                      disabled={isSubmitting}
                    />
                  ) : (
                    <h3 className="success">
                      <img src={Success} alt="" />
                      <p>
                        Thanks for subscribing! <br />
                        We'll be in touch soon.
                      </p>
                    </h3>
                  )}

                  <div className="signup-honeypot" aria-hidden="true">
                    <label htmlFor="newsletter-popup-website">Website</label>
                    <input
                      type="text"
                      name="website"
                      id="newsletter-popup-website"
                      tabIndex="-1"
                      autoComplete="off"
                      value={values.website}
                      onChange={event => {
                        resetFeedback()
                        handleChange(event)
                      }}
                    />
                  </div>

                  {!isSuccess && (
                    <button type="submit" disabled={isSubmitting}>
                      {submitButtonText || "Submit"}
                    </button>
                  )}
                  <ErrorMessage
                    className="errorMessage"
                    showError={errors.email || submitError}
                    name="email"
                    style={{
                      display: errors.email || submitError ? "flex" : "none",
                    }}
                  >
                    <ErrorIcon />
                    <p>{errors.email || submitError}</p>
                  </ErrorMessage>
                </FormWrapper>
              )}
            </Formik>
          </Container>
        </Overlay>
      )}
    </div>
  )
}

export default NewsletterPopup
